import { render, staticRenderFns } from "./PopupInfos.vue?vue&type=template&id=d18c1438"
import script from "./PopupInfos.vue?vue&type=script&lang=js"
export * from "./PopupInfos.vue?vue&type=script&lang=js"
import style0 from "./PopupInfos.vue?vue&type=style&index=0&id=d18c1438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports